import { render, staticRenderFns } from "./CityList.vue?vue&type=template&id=5d4582a6"
import script from "./CityList.vue?vue&type=script&lang=js"
export * from "./CityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports